module.exports = "/assets/data/660fa747f908692ed713d090e80ba0fa-G3.data.json";